import React, { useEffect, useContext, useMemo } from 'react'
import * as classes from './Competencies.module.scss'
import cn from 'classnames'
import SectionTitle from '../../../ui/SectionTitle/SectionTitle'
import splitRow from '../../../../utils/splitRow'
import { FormContext } from '../../../../context'
import { useDataCompetencies } from './useDataCompetencies'
import { deleteHtmlTag } from '../../../../utils/deleteHtmlTag'
import { startAnimationScroll } from '../../../../utils/animations'
import { useDataCompetenciesByEn } from './useDataCompetenciesByEn'

function parseItem(rawHtml) {
    const clean = deleteHtmlTag(rawHtml, 'p')
        .replace(/<br\s*\/?>/gi, ' ')
        .trim()

    const [itemTitle, ...rest] = clean.split(':')

    return {
        title: (itemTitle || '').trim(),
        text: rest.join(':').trim()
    }
}

function Competencies({ lang }) {
    const dataByHy = useDataCompetencies()
    const dataByEn = useDataCompetenciesByEn()

    const data = lang === 'hy' ? dataByHy : dataByEn

    const title = useMemo(() => deleteHtmlTag(data.title.value, 'p'), [])
    const text = useMemo(() => deleteHtmlTag(data.text.value, 'p'), [])

    const heroImage = useMemo(() => data.heroImage?.image?.url, [data.heroImage])

    const items = useMemo(
        () => (data.items && data.items.nodes ? data.items.nodes.map((item) => ({ ...parseItem(item.text), image: item.image })) : []),
        []
    )

    const { animationStart } = useContext(FormContext)

    const classAnimationText = 'anime-text-competencies'
    const classAnimationLine = 'anime-line-competencies'

    useEffect(() => {
        if (animationStart) {
            splitRow(classAnimationText)
        }

        const observer = startAnimationScroll([
            { type: 'text', className: classAnimationText },
            { type: 'lineGorizont', className: classAnimationLine }
        ])

        return () => {
            if (observer) {
                observer.disconnect()
            }
        }
    }, [animationStart])

    return (
        <section className={cn(classes.Section, { [classes.LangHY]: lang === 'hy' })}>
            <div className={classes.HeroWrap}>
                <div className={classes.HeroImage} style={{ backgroundImage: `url(${heroImage})` }}>
                    {title || text ? (
                        <div className={classes.Content}>
                            {title ? <SectionTitle className={classes.SectionTitle} title={title} lang={lang} /> : null}

                            {text ? (
                                <div
                                    className={classes.Text + ' anime-scroll ' + classAnimationText}
                                    dangerouslySetInnerHTML={{ __html: text }}
                                />
                            ) : null}
                        </div>
                    ) : null}
                </div>
            </div>
            {items.length ? (
                <div className={classes.Items}>
                    {items.map((item, index) => (
                        <div className={classes.Item} key={index} style={{ backgroundImage: `url(${item.image?.url})` }}>
                            <div className={classes.Card}>
                                {item.title ? <p className={classes.ItemTitle}>{item.title}</p> : null}
                                {item.text ? <p className={classes.ItemText}>{item.text}</p> : null}
                            </div>

                        </div>
                    ))}
                </div>
            ) : null}
        </section>
    )
}

export default Competencies
